import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ICustomer } from "@defs/customer";

interface ReferralsState {
  loading: boolean;
  management: {
    data: ICustomer;
    loading: boolean;
  };
}

const initialState: ReferralsState = {
  loading: false,
  management: {
    data: null,
    loading: true,
  },
};

const referralsSlice = createSlice({
  name: "referrals",
  initialState,
  reducers: {},
  extraReducers: {
    "referrals/list/pending": (state) => {
      state.management = initialState.management;
    },

    "referrals/list/fulfilled": (state, action: PayloadAction<ICustomer>) => {
      state.management.loading = false;
      state.management.data = action.payload;
    },
  },
});

export const referralsActions = referralsSlice.actions;

export default referralsSlice.reducer;
